import { FaHome, FaSitemap, FaUsers } from "react-icons/fa";
import Dashboard from "../pages/Dashboard/Dashboard";
import Login from "../pages/Login/Login";
import MainScreen from "../pages/MainScreen/MainScreen";
import Users from "../pages/Users/Users";
import { TbCategoryFilled, TbTexture } from "react-icons/tb";
import Category from "../pages/Category/Category";
import Settings from "../pages/Settings/Settings";
import VendorDashboard from "../pages/Dashboard/VendorDashboard";
import Store from "../pages/Store/Store";
import { FaShop } from "react-icons/fa6";
import StoreManagement from "../pages/StoreManagement/StoreManagement";
import StoreDetail from "../pages/StoreDetail/StoreDetail";
import ProductManagement from "../pages/ProductManagement/ProductManagement";
import AddProduct from "../pages/ProductManagement/AddProduct";
import ProductDetail from "../pages/ProductManagement/ProductDetail";
import EditProduct from "../pages/ProductManagement/EditProduct";
import SizeManagement from "../pages/Sizes/Sizes";
import { SlSizeFullscreen } from "react-icons/sl";
import { FaCartShopping } from "react-icons/fa6";
import FabricManagement from "../pages/Fabric/Fabric";
import { GiRolledCloth } from "react-icons/gi";
import FinishingManagement from "../pages/Finishings/Finishing";
import { FaBoxOpen } from "react-icons/fa6";
import OrderManagement from "../pages/Orders/OrderManagement";
import OrderDetail from "../pages/Orders/OrderDetail";
import { FaQuoteRight } from "react-icons/fa";
import CustomQuote from "../pages/QuotesManagement/QuotesManagement";
import Variants from "../pages/VariantsManagement/Variants";
import { PiDotsNineBold } from "react-icons/pi";
import FormSubmissions from "../pages/Contact&Newsletter/ContactNewsletter";
import { IoNewspaper } from "react-icons/io5";
import TypeManagement from "../pages/TypeManagement/TypeManagement";
import { MdCategory } from "react-icons/md";
import OrderPreview from "../pages/Orders/OrderPreview";
import CustomerManagement from "../pages/CustomerManagment/CustomerManagment";
import SiteMap from "../pages/Sitemap/Sitemap";

export const mainRoutes = [
  {
    screenName: "Dashboard",
    path: "/*",
    element: <MainScreen />,
    authRequired: true,
  },
  {
    screenName: "Login",
    path: "/login",
    element: <Login />,
    authRequired: false,
  },
];

export const admin_sidebar_route = [
  {
    screenName: "Dashboard",
    path: "/",
    icon: <FaHome />,
    element: <Dashboard />,
    isShow: true,
  },
  {
    screenName: "Users",
    path: "/users",
    icon: <FaUsers />,
    element: <Users />,
    isShow: true,
  },
  {
    screenName: "Collections",
    path: "/categories",
    icon: <TbCategoryFilled />,
    element: <Category />,
    isShow: true,
  },
  {
    screenName: "Variants",
    path: "/variants",
    icon: <PiDotsNineBold />,
    element: <Variants />,
    isShow: true,
  },
  // {
  //   screenName: "Add Sizes",
  //   path: "/sizes",
  //   icon: <SlSizeFullscreen />,
  //   element: <SizeManagement />,
  //   isShow: true,
  // },
  // {
  //   screenName: "Add Fabrics",
  //   path: "/fabric",
  //   icon: <TbTexture />,
  //   element: <FabricManagement />,
  //   isShow: true,
  // },
  // {
  //   screenName: "Add Finishing",
  //   path: "/finishing",
  //   icon: <GiRolledCloth />,
  //   element: <FinishingManagement />,
  //   isShow: true,
  // },
  {
    screenName: "Store",
    path: "/store",
    icon: <FaHome />,
    element: <Store />,
    isShow: false,
  },
  {
    screenName: "Store Management",
    path: "/store-management",
    icon: <FaShop />,
    element: <StoreManagement />,
    isShow: true,
  },
  {
    screenName: "Store Management",
    path: "/store-management/:id",
    icon: <FaShop />,
    element: <StoreDetail />,
    isShow: false,
  },
  {
    screenName: "Customer Managment",
    path: "/customer-managment",
    icon: <FaShop />,
    element: <CustomerManagement />,
    isShow: true,
  },
  {
    screenName: "Order Management",
    path: "/order-management",
    icon: <FaCartShopping />,
    element: <OrderManagement />,
    isShow: true,
  },
  {
    screenName: "Order Management",
    path: "/order-management/:id",
    icon: <FaCartShopping />,
    element: <OrderPreview />,
    isShow: false,
  },
  {
    screenName: "Custom Quotes",
    path: "/custom-quotes",
    icon: <FaQuoteRight />,
    element: <CustomQuote />,
    isShow: true,
  },
  {
    screenName: "Custom Quotes",
    path: "/custom-quotes/:id",
    icon: <FaQuoteRight />,
    element: <CustomQuote />,
    isShow: false,
  },
  {
    screenName: "Products",
    path: "/products",
    icon: <FaBoxOpen />,
    element: <ProductManagement />,
    isShow: true,
  },
  {
    screenName: "Contact & Newsletter",
    path: "/contact-newsletter-management",
    icon: <IoNewspaper />,
    element: <FormSubmissions />,
    isShow: true,
  },
  {
    screenName: "Type Management",
    path: "/type-management",
    icon: <MdCategory  />,
    element: <TypeManagement />,
    isShow: false,
  },

  {
    screenName: "Product",
    path: "/products/add-products",
    icon: <FaBoxOpen />,
    element: <AddProduct />,
    isShow: false,
  },
  {
    screenName: "Product",
    path: "/products/edit-products/:id",
    icon: <FaBoxOpen />,
    element: <EditProduct />,
    isShow: false,
  },
  {
    screenName: "Product",
    path: "/products/product-detail/:id",
    icon: <FaBoxOpen />,
    element: <ProductDetail />,
    isShow: false,
  },
  {
    screenName: "Sitemap",
    path: "/sitemap-management",
    icon: <FaSitemap />,
    element: <SiteMap />,
    isShow: true,
  },
];


export const vendor_sidebar_route = [
  {
    screenName: "Dashboard",
    path: "/",
    icon: <FaHome />,
    element: <VendorDashboard />,
    isShow: true,
  },
  {
    screenName: "Setting",
    path: "/setting",
    icon: <FaHome />,
    element: <Settings />,
    isShow: false,
  },
  {
    screenName: "Store",
    path: "/store",
    icon: <FaHome />,
    element: <Store />,
    isShow: false,
  },
  {
    screenName: "Products",
    path: "/products",
    icon: <FaBoxOpen />,
    element: <ProductManagement />,
    isShow: true,
  },

  {
    screenName: "Product",
    path: "/products/add-products",
    icon: <FaBoxOpen />,
    element: <AddProduct />,
    isShow: false,
  },
  {
    screenName: "Product",
    path: "/products/edit-products/:id",
    icon: <FaBoxOpen />,
    element: <EditProduct />,
    isShow: false,
  },
  {
    screenName: "Product",
    path: "/products/product-detail/:id",
    icon: <FaBoxOpen />,
    element: <ProductDetail />,
    isShow: false,
  },
  {
    screenName: "Order Management",
    path: "/order-management",
    icon: <FaCartShopping />,
    element: <OrderManagement />,
    isShow: true,
  },
  {
    screenName: "Order Management",
    path: "/order-management/:id",
    icon: <FaCartShopping />,
    element: <OrderPreview />,
    isShow: false,
  },
  {
    screenName: "Custom Quotes",
    path: "/custom-quotes",
    icon: <FaQuoteRight />,
    element: <CustomQuote />,
    isShow: true,
  },
];
